import React from 'react';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import PerfectScrollbarStyle from '@bit/knotchinc.web-react-components.perfect-scrollbar-style';
import Home from 'components/Pages/Home/Home.jsx';
import BlueprintNav from 'components/BlueprintNav/BlueprintNav.jsx';
import BlueprintTrialWindow from 'components/Global/BlueprintTrialWindow/BlueprintTrialWindow.jsx';
import bugsnag from 'helpers/bugsnag.js';
import Config from 'Config';
import ReactGA from 'react-ga';
import Mixpanel from 'helpers/Mixpanel.js';
import { displayOnboardingModal } from 'actions/userAnalytics.js';
import LibraryView from 'components/Pages/Library/LibraryView.jsx';
import PublisherView from 'components/Pages/Entity/PublisherView.jsx';
import BrandView from 'components/Pages/Entity/BrandView.jsx';
import PartnershipView from 'components/Pages/Entity/Partnership/PartnershipView.jsx';
import SettingsView from 'components/Pages/Settings/SettingsView.jsx';
import TopBar from 'components/TopBar/TopBar.jsx';
import SearchFeedView from 'components/Pages/SearchFeed/SearchFeedView.jsx';
import ContentView from 'components/Pages/ContentView/ContentView.jsx';
import BrandHubView from 'components/Pages/Entity/BrandHub/BrandHubView.jsx';

import ReportListView from 'components/Pages/Reports/ReportList/ReportListView.jsx';
import ReportWebView from 'components/Pages/Reports/web/ReportWebView.jsx';
import ReportPrintView from 'components/Pages/Reports/print/ReportPrintView.jsx';

require('style/Brandon.less');


function onUpdate() {
  window.scrollTo(0, 0);
  const pageUri = window.location.pathname;
  bugsnag.breadCrumb('navigated', { pageUri });

  if (Config.gAnalytics.enabled) {
    ReactGA.set({ page: pageUri });
    ReactGA.pageview(pageUri);
  }

  return null;
}

// MAIN PAGE
export class App extends React.Component {
  componentDidMount() {
    if (Config.gAnalytics.enabled) {
      ReactGA.initialize(Config.gAnalytics.code);
    }

    Mixpanel.init({ product: 'blueprint2' });
    onUpdate();
    this.props.history.listen(args => onUpdate(args));
    this.props.shouldDisplayOnboarding();
  }


  render() {
    const { location: { pathname } } = this.props;
    const isPrintView = pathname.includes('/print/');
    return (
      <React.Fragment>
        <PerfectScrollbarStyle />
        {!isPrintView && <BlueprintNav />}
        {!isPrintView && <div id="mainWrapper">
          {!isPrintView && <TopBar pathname={pathname} />}
          <Switch>
            <Route exact path="/blueprint" component={Home} />
            <Route path="/blueprint/settings" component={SettingsView} />
            {/* library */}
            <Route path="/blueprint/library" component={LibraryView} />
            <Route path="/blueprint/search" component={SearchFeedView} />
            {/* content view */}
            <Route path="/blueprint/content/:contentId" component={ContentView} />
            <Route path="/blueprint/brand/:entityId/hub/:hubId" component={BrandHubView} />
            <Route path="/blueprint/:entityType/:entityId/:partnerType/:partnerId" component={PartnershipView} />
            <Route path="/blueprint/brand/:entityId" component={BrandView} />
            <Route path="/blueprint/publisher/:entityId" component={PublisherView} />
            <Route exact path="/blueprint/reports/" component={ReportListView} />
            <Route exact path="/blueprint/reports/:reportId" component={ReportWebView} />
          </Switch>
          <BlueprintTrialWindow />
        </div>}
        <Route path="/blueprint/reports/print/:reportId" component={ReportPrintView} />
      </React.Fragment>
    );
  }
}


const mapDispatchToProps = dispatch => ({
  shouldDisplayOnboarding: () => dispatch(displayOnboardingModal()),
});

export default connect(null, mapDispatchToProps)(App);
